import { render, staticRenderFns } from "./TagDetail.vue?vue&type=template&id=b353d24c&scoped=true"
import script from "./TagDetail.vue?vue&type=script&lang=js"
export * from "./TagDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b353d24c",
  null
  
)

export default component.exports